const queryUtils = (() => {
  const createQueryStringFromObject = (
    queryObject: object,
    initValue?: string,
  ): string => {
    const queryList: string[] = []
    Object.keys(queryObject).forEach((key: keyof typeof queryObject) =>
      queryList.push(`${key}=${queryObject[key]}`),
    )

    const queryString = queryList.join('&')

    if (initValue) {
      return initValue + queryString
    }
    return queryString
  }

  const parseQueryNumberParam = (queryParams: any, paramName: string) => {
    if (
      queryParams[paramName] &&
      parseInt(queryParams[paramName].toString(), 0)
    ) {
      return parseInt(queryParams[paramName].toString(), 0)
    }
  }

  const parseQueryBooleanParam = (param: string) => {
    if (param === 'true') {
      return true
    } else if (param === 'false') {
      return false
    } else {
      return undefined
    }
  }

  return {
    createQueryStringFromObject,
    parseQueryNumberParam,
    parseQueryBooleanParam,
  }
})()

export { queryUtils }
